<template>
  <div class="view-tasklists account-lookup">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu v-if="masterAdmin == true" />
      <researcher-sidebar-menu v-if="researcher == true" />
      <CSRSidebarMenu v-if="csr == true" />
      <div class="content-wrapper">
      <div class="container-wrapper center" >

        <div class="modal-custom" v-show="showOverlay">
          <div class="loader-img-center">
            <i class="fa fa-spinner fa-spin"></i> Please wait...
          </div>
        </div>

        <div class="col-12 override-padding">
          <h3 class="d-inline heading">Account Lookup</h3>
          <span class="float-right">
            <button
                v-if="(accountId > 0)"
                v-on:click="clearSearchAction()"
                class="btn btn-grey btn-md input-height-15"
                >Clear Search</button>
            <button
                v-if="((accountId > 0) && (!$route.params.account_id))"
                :disabled="((this.$route.query.count) && (this.$route.query.count == 0))"
                v-on:click="previousPagination()"
                class="btn btn-red btn-md input-height-15"
                >Previous</button>
            <button
                v-if="((accountId > 0) && (!$route.params.account_id))"
                :disabled="((this.$route.query.count >= 0) && ((parseInt(this.$route.query.count) + parseInt(1)) === this.total_pages))"
                v-on:click="nextPagination()"
                class="btn btn-red btn-md input-height-15"
                >Next</button>
          </span>
        </div>
        <div class="heading-seperator"></div>
        <div style="clear: both; float: none;" class="col-12 margin-bottom-10"></div>
        <flash-message autoHide variant="success"></flash-message>
        <flash-message autoHide variant="danger"></flash-message>
        <flash-message variant="warning"></flash-message>
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="success"
          @dismissed="dismissCountDown=0"
          @dismiss-count-down="countDownChanged"
          >
          {{ success_message }}
        </b-alert>
        <div style="clear: both"></div>

        <input
            type="hidden"
            name="accountId"
            id="accountId"
            class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
            ref="accountId"
            v-model="accountId">

        <div class="row search-padd"
        :class="{ 'account_lookup_details' : (showOverlay==true) }"
        >
        <form @change="addEvent" v-on:submit.prevent>
          <div class="org_details">
            <div class="col-md-4 float-left override-padding">
              <div class="col-12">
                <input
                    type="text"
                    name="accountName"
                    id="org_name"
                    class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                    ref="org_name"
                    v-model="org_name"
                    v-validate="'required'"
                    placeholder="Account Name"
                    maxlength="250"
                    :disabled="researcher_disable === true"
                    @keydown.enter.prevent='searchAction'>
                <div v-if="verrors.firstByRule('accountName', 'required')" class="margin-bottom-5 validate-warning-msg">Account name is required</div>
                <div v-if="verrors.firstByRule('accountName', 'exists')" class="margin-bottom-5 validate-warning-msg">Account name already exists</div>

                <div class="col-12 col-md-12 override-padding">
                  <div class="col-md-10 float-left padding-lr-5" style="padding-left: 0">
                    <input
                        type="text"
                        name="website"
                        id="website"
                        class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                        ref="website"
                        v-model="website"
                        placeholder="Website"
                        maxlength="250"
                        @keydown.enter.prevent='searchAction'>
                  </div>
                  <div class="col-md-2 float-left override-padding">
                    <Button
                      v-on:click="website_redirect()"
                      :disabled="((website == '') || (accountId == 0))"
                      class="col-12 btn btn-red edit-action-btn margin-bottom-5" style="cursor: pointer;"
                      >GO</Button>
                  </div>
                </div>

                <div class="col-12 col-md-12 override-padding">
                  <div class="col-md-10 float-left padding-lr-5" style="padding-left: 0">
                    <input
                        type="text"
                        name="phoneNumber"
                        id="org_phone"
                        class="col-md-12 input-height-30 padding-lr-5 margin-bottom-5"
                        ref="org_phone"
                        v-model="org_phone"
                        placeholder="Phone No"
                        @keyup="phoneValid"
                        @blur="phoneValid"
                        v-validate="{ rules: { regex: phoneRegex() } }"
                        maxlength="14"
                        :disabled="researcher_disable === true"
                        @keydown.enter.prevent='searchAction'>
                    <div v-if="verrors.has('phoneNumber')" class="margin-bottom-5 validate-warning-msg">Phone number is invalid</div>
                  </div>
                  <div class="col-md-2 float-left override-padding">
                    <input
                        type="text"
                        name="phoneExt"
                        id="org_phone_ext"
                        class="col-md-12 input-height-30 padding-lr-5 margin-bottom-5"
                        ref="org_phone_ext"
                        v-model="org_phone_ext"
                        placeholder="Ext"
                        @keyup="phoneExtValid"
                        @blur="phoneExtValid"
                        :disabled="researcher_disable === true"
                        maxlength="3" @keydown.enter.prevent='searchAction'>
                  </div>
                </div>
                <input
                    type="text"
                    name="fax"
                    id="fax"
                    class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                    ref="fax"
                    v-model="fax"
                    placeholder="Fax"
                    @keyup="faxValid"
                    @blur="faxValid"
                    v-validate="{ rules: { regex: phoneRegex() } }"
                    maxlength="14"
                    :disabled="researcher_disable === true"
                    @keydown.enter.prevent='searchAction'>
                <div v-if="verrors.has('fax')" class="margin-bottom-5 validate-warning-msg">Fax is invalid</div>
                <div class="col-12 col-md-12 override-padding">
                  <div class="col-md-6 float-left padding-lr-5" style="padding-left: 0">
                    <b-form-select
                        class="col-md-12 input-height-30 padding-lr-5 margin-bottom-5"
                        name="status"
                        v-model="status"
                        :options="status_options"
                        v-on:change="status_change()"
                        :disabled="isStatusDisable">
                        </b-form-select>
                        <div v-if="verrors.firstByRule('status', 'required')" class="margin-bottom-5 validate-warning-msg">Status is required</div>
                  </div>
                  <div class="col-md-6 float-left override-padding">
                    <input
                        type="text"
                        readonly="readonly"
                        name="status_updated_on"
                        id="status_updated_on"
                        class="col-md-12 input-height-30 padding-lr-5 margin-bottom-5"
                        ref="status_updated_on"
                        v-model="status_updated_on"
                        placeholder=""
                        maxlength="150" @keydown.enter.prevent="">
                  </div>
                </div>
                <div v-if="(accountId > 0)" class="col-12 col-md-12 override-padding">
                  <div class="col-md-6 float-left padding-lr-5" style="padding-left: 0">
                    <input
                        type="text"
                        readonly="readonly"
                        name="primary_fname"
                        id="primary_fname"
                        class="col-md-12 input-height-30 padding-lr-5 margin-bottom-5"
                        ref="primary_fname"
                        v-model="primary_fname"
                        placeholder="First Name"
                        maxlength="150" @keydown.enter.prevent="">
                  </div>
                  <div class="col-md-6 float-left override-padding">
                    <input
                        type="text"
                        readonly="readonly"
                        name="primary_lname"
                        id="primary_lname"
                        class="col-md-12 input-height-30 padding-lr-5 margin-bottom-5"
                        ref="primary_lname"
                        v-model="primary_lname"
                        placeholder="Last Name"
                        maxlength="150" @keydown.enter.prevent="">
                  </div>
                </div>
                <input
                    v-if="(accountId > 0)"
                    type="text"
                    readonly="readonly"
                    name="primary_email"
                    id="primary_email"
                    class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                    ref="primary_email"
                    v-model="primary_email"
                    placeholder="Email"
                    maxlength="150" @keydown.enter.prevent="">
              </div>
            </div>

            <div class="col-md-4 float-left override-padding">
              <div class="col-12">
                <input
                    type="text"
                    name="location api"
                    id="location_api"
                    class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                    ref="location_api"
                    placeholder="Enter your city or location"
                    onfocus="value = ''"
                    value=""
                    :disabled="researcher_disable === true"
                    maxlength="250" @keydown.enter.prevent="">
                <div class="col-12 col-md-12 override-padding">
                  <div class="col-md-10 float-left padding-lr-5" style="padding-left: 0">
                    <b-form-select 
                        name="countryCode" 
                        class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                        v-model="org_country"
                        :options="country_options"
                        v-on:change="getStateLists(org_country)" :disabled="researcher_disable === true">
                        </b-form-select>
                  </div>
                  <div class="col-md-2 float-left override-padding">
                    <button
                      v-on:click="updateCountryUS()"
                      class="col-12 btn btn-red edit-action-btn margin-bottom-5" :disabled="researcher_disable === true"
                      >US</button>
                  </div>
                </div>
                <input
                    type="text"
                    name="address"
                    id="org_address"
                    class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                    ref="org_address"
                    v-model="org_address"
                    placeholder="Address 1"
                    maxlength="250"
                    :disabled="researcher_disable === true"
                    @keydown.enter.prevent='searchAction'>
                <input
                    type="text"
                    name="address2"
                    id="org_address2"
                    class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                    ref="org_address2"
                    v-model="org_address2"
                    placeholder="Address 2"
                    maxlength="250"
                    :disabled="researcher_disable === true"
                    @keydown.enter.prevent='searchAction'>
                <input
                    type="text"
                    name="city"
                    id="org_city"
                    class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                    ref="org_city"
                    v-model="org_city"
                    placeholder="City"
                    maxlength="100"
                    :disabled="researcher_disable === true"
                    @keydown.enter.prevent='searchAction'>
                <b-form-select 
                    name="state" 
                    class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                    v-model="org_state"
                    :disabled="researcher_disable === true"
                    :options="state_options">
                    </b-form-select>
                <input
                    type="text"
                    name="zip"
                    id="org_zip"
                    class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                    ref="org_zip"
                    v-model="org_zip"
                    placeholder="Postal Code"
                    v-validate="{ rules: { regex: getPostalCodeRegex() } }"
                    maxlength="10"
                    :disabled="researcher_disable === true"
                    @keydown.enter.prevent='searchAction'>
                <div v-if="verrors.has('zip')" class="margin-bottom-5 validate-warning-msg">Postal code is invalid</div>
                <input
                    type="text"
                    name="marketArea"
                    id="org_market_area"
                    class="col-12 col-sm-12 input-height-30 padding-lr-5 margin-bottom-5"
                    ref="org_market_area"
                    v-model="org_market_area"
                    placeholder="Market Area"
                    maxlength="100"
                    :disabled="researcher_disable === true"
                    @keydown.enter.prevent='searchAction'>
              </div>
            </div>

            <div class="col-md-4 float-left override-padding">
              <div class="col-12">
                <div class="col-12 override-padding">
                  <div class="col-md-3 float-left override-padding">

                    <autocomplete
                      ref="autocomplete1"
                      :place-holder-text="placeHolderInputText"
                      :result-items="autoCompleteNaicsCodeResult"
                      :on-key-up="onKeyUpAutoCompleteNaicsCode"
                      :on-selected="onSelectedAutoCompleteNaicsCode"
                      :auto-complete-progress="autoCompleteNaicsCodeProgress"
                      :keywordSearch="naics_code"
                      :classValue="'col-md-11 padding-lr-5 input-height-30 margin-bottom-5'"
                      :styleValue="'width: 300px;'"
                      :maxlength="5">
                   </autocomplete>

                  </div>
                  <div class="col-md-1 float-left override-padding">
                    <label
              					for="to"
              					class="col-md-11 override-padding" style="padding-top: 5px;padding-left: 5px;">to</label>
                  </div>
                  <div class="col-md-3 float-left override-padding">

                    <autocompleteTo
                      ref="autocomplete2"
                      :place-holder-text="placeHolderInputText"
                      :result-items="autoCompleteNaicsCodeToResult"
                      :on-key-up="onKeyUpAutoCompleteNaicsCodeTo"
                      :on-selected="onSelectedAutoCompleteNaicsCodeTo"
                      :auto-complete-progress="autoCompleteNaicsCodeToProgress"
                      :keywordSearch="naics_to_code"
                      :classValue="'col-md-11 padding-lr-5 input-height-30 margin-bottom-5'"
                      :styleValue="'width: 100px;'"
                      :maxlength="5">
                   </autocompleteTo>

                  </div>
                  <div class="col-md-5 float-left override-padding">
                    <b-form-select 
                        name="naicsId" 
                        class="col-md-12 padding-lr-5 input-height-30 margin-bottom-5"
                        v-model="naics_id"
                        :options="naics_id_options"
                        v-on:change="removeNAICSValue()">
                        </b-form-select>
                  </div>
                </div>

               <div style="clear: both;"></div>

                <div class="col-12 col-md-12 override-padding">
                  <div class="col-md-9 float-left padding-lr-5" style="padding-left: 0">

                      <autocompleteDescription
                        ref="autocomplete3"
                        :place-holder-text="placeHolderInputText"
                        :result-items="autoCompleteDescriptionResult"
                        :on-key-up="onKeyUpAutoCompleteDescription"
                        :on-selected="onSelectedAutoCompleteDescription"
                        :auto-complete-progress="autoCompleteDescriptionProgress"
                        :keywordSearch="naics_description"
                        :classValue="'col-12 input-height-30 padding-lr-5 margin-bottom-5'"
                        :styleValue="'width: 100%;'"
                        :maxlength="250">
                     </autocompleteDescription>

                  </div>
                  <div class="col-md-3 float-left override-padding">
                    <button
                      v-on:click="naicsListModal"
                      class="col-12 btn btn-red edit-action-btn margin-bottom-5"
                      >NAICS</button>
                  </div>
                </div>
                <div class="col-12 col-md-12 override-padding">
                  <div class="col-md-4 float-left padding-lr-5" style="padding-left: 0">
                    <b-form-select
                        name="naicsLabel" 
                        class="col-md-12 input-height-30 padding-lr-5 margin-bottom-5"
                        v-model="naics_label"
                        :options="naics_label_options">
                        </b-form-select>
                  </div>
                  <div class="col-md-4 float-left padding-lr-5" style="padding-left: 0">
                    <b-form-select
                        class="col-md-12 input-height-30 padding-lr-5 margin-bottom-5"
                        name="program"
                        v-model="program"
                        :options="program_options"
                        v-on:change="program_change()"
                        v-validate="'required'" :disabled="researcher_disable === true">
                        </b-form-select>
                        <div v-if="verrors.firstByRule('program', 'required')" class="margin-bottom-5 validate-warning-msg">Program is required</div>
                  </div>
                  <div class="col-md-4 float-left override-padding">
                    <b-form-select
                        class="col-md-12 input-height-30 padding-lr-5 margin-bottom-5"
                        v-model="org_type"
                        name="enterpriseType"
                        :disabled="account_type_disable === true"
                        v-on:change="org_type_change()"
                        v-validate="'required'" 

                        :options="org_type_options">
                        </b-form-select>
                    <div v-if="verrors.firstByRule('enterpriseType', 'required')" class="margin-bottom-5 validate-warning-msg">Account type is required</div>
                  </div>
                </div>
                <textarea
                    name="researcherNotes" 
                    v-model="researcher_notes"
                    placeholder="Researcher Notes"
                    class="textarea col-xs-12 col-md-12 col-lg-12 padding-lr-5 input-height-25"
                    maxlength="500">
                    </textarea>
                <div class="col-12 col-md-12 override-padding">
                <div class="col-md-7 float-left override-padding text-align-right" style="padding-left: 0">
                <button v-if="(accountId > 0 && researcher == false)"
                 @click="displayEmailLoginList()"
                 class="btn btn-red btn-md btn-block input-height-15">
                 Email or Login as Admin</button>
                </div>
                  <div class="col-md-5 float-right override-padding text-align-right" style="padding-left: 0">
                    <button
                        v-if="(accountId > 0 && status != 'Delete' && researcher == false && csr == false)"
                        @click="isModalVisible = true"
                        class="btn btn-red btn-md input-height-15"
                        >Task Lists</button>
                  </div>
                </div>

              </div>
            </div>

          </div>
          </form>
          <div style="clear: both; float: none;" class="col-12 margin-bottom-20"></div>

          <div
            class="tabs float-left override-padding"
            :class="(accountId > 0) ? 'width-90' : 'col-9'"
          >
            <div class="col-12">
            <ul class="nav nav-tabs tab-bg col-12">
              <li id="admin_view" :class="{active: selectedComponent === 'AdminTab'}"><a id="" class="cursor-pointer active" @click="selectedComponent='AdminTab'">Admin</a></li>
              <li v-if="(accountId > 0)" id="notes_view" :class="{active: selectedComponent === 'NotesTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='NotesTab'">Notes</a></li>
              <li v-if="(accountId > 0 && researcher == false)" id="orders_view" :class="{active: selectedComponent === 'OrdersTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='OrdersTab'">Orders</a></li>
              <li v-if="(accountId > 0 && researcher == false)" id="purchasing_view" :class="{active: selectedComponent === 'PurchasingTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='PurchasingTab'">Purchasing</a></li>
              <li v-if="(accountId == 0 && researcher == false)" id="mentee_view" :class="{active: selectedComponent === 'SearchMenteeTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='SearchMenteeTab'">{{ mentee_tab_name }}</a></li>
              <li v-if="(accountId > 0 && researcher == false)" id="mentee_view" :class="{active: selectedComponent === 'MenteeTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='MenteeTab'">{{ mentee_tab_name }}</a></li>
              <li v-if="(accountId > 0)" id="mentee_view" :class="{active: selectedComponent === 'PathwayTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='PathwayTab'">Pathways</a></li>
              <li v-if="(accountId > 0 && researcher == false)" id="menu_view" :class="{active: selectedComponent === 'MenuTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='MenuTab'">Menu</a></li>
              <li v-if="accountId == 0" id="affiliates_view" :class="{active: selectedComponent === 'AffiliateTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='AffiliateTab'">Affiliates</a></li>
              <li v-if="(accountId > 0 && researcher == false)" id="affiliates_view" :class="{active: selectedComponent === 'AffiliateTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='AffiliateTab'">Affiliates</a></li>
               <li v-if="accountId == 0" id="industry_view" :class="{active: selectedComponent === 'IndustryTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='IndustryTab'">Industry</a></li>
              <li v-if="(accountId > 0 && researcher == false)" id="industry_view" :class="{active: selectedComponent === 'IndustryTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='IndustryTab'">Industry</a></li>
              <li v-if="((accountId > 0) && (org_type == 'School') && (researcher == false))" id="groups_view" :class="{active: selectedComponent === 'GroupTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='GroupTab'">Group</a></li>
              <li v-if="((accountId == 0))" id="forms_view" :class="{active: selectedComponent === 'SearchFormTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='SearchFormTab'">Forms</a></li>
              <li v-if="(accountId > 0 && researcher == false)" id="enterprise_view" :class="{active: selectedComponent === 'EnterpriseTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='EnterpriseTab'">Enterprise</a></li>
              <li v-if="(accountId > 0)" id="history_view" :class="{active: selectedComponent === 'HistoryTab'}"><a id="" class="cursor-pointer" @click="selectedComponent='HistoryTab'">History</a></li>
            </ul>
            </div>
         </div>
         <div
          class="float-right text-align-right override-padding"
          :class="(accountId > 0) ? 'width-10' : 'col-3'"
        >
           <div class="col-12">
             <button
                 v-if="(accountId == 0)"
                 v-on:click="searchAction()"
                 class="btn btn-red btn-md input-height-15"
                 >Search</button>
             <button
                 v-if="(accountId == 0)"
                 v-on:click="checkValidation()"
                 class="btn btn-red btn-md input-height-15"
                 >Insert</button>
             <button
                 v-if="(accountId > 0 && status != 'Delete')"
                 v-on:click="update_selected_tab_details()"
                 class="btn btn-red btn-md input-height-15"
                 >Update</button>
           </div>
         </div>
         <component 
          :is="selectedComponent" 
          :ref="selectedComponent" 
          :accountId=accountId 
          :accountStatus=status 
          :researcherDisable=researcher_disable
          :program=program>
         </component>
        </div>
      </div>
    </div>

    <CreateTasklistModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <div slot="header" class="sub-heading"><h3>Create Tasklist</h3></div>
      <div slot="body">
        <div class="col-11 override-padding">
          <div class="col-lg-6 col-12 float-left override-padding create_tasks_status">
            <div class="col-lg-5 float-left col-12 override-padding" v-for="(option, index) in tasklists_options">
              <input :value="option.value" type="radio" v-on:change="tasklistsOptions()" name="tasklists_option" v-model="tasklists_option">
              <label>{{ option.text }}</label>
            </div>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div class="col-11 override-padding" v-show="new_fields" v-if="(new_fields == true && isModalVisible == true)">
          <input v-model="tasklist_title"
                placeholder="Enter Tasklist Title"
                class="col-lg-9 col-sm-9 col-7 input-height-25"
                name="tasklist_title"
                v-validate="'required'"
                maxlength="255" />
          <button
              v-on:click="createTasklist()"
              class="btn btn-red col-lg-2 col-sm-2 col-3 input-height-30"
              ><b>Create</b></button>
          <div v-if="verrors.firstByRule('tasklist_title', 'required')" class="margin-bottom-5 validate-warning-msg">Tasklist Tile is required</div>
        </div>
        <div class="col-11 override-padding" v-show="existing_fields"  v-if="(existing_fields == true && isModalVisible == true)">
          <b-form-select
            class="col-lg-9 col-sm-9 col-7 input-height-25"
            v-model="selected_publicTasklists"
            v-validate="'required'"
            name="selected_publicTasklists"
            :options="publicTasklists"></b-form-select>
          <button
              v-on:click="cloneTasklist()"
              class="btn btn-red col-lg-2 col-sm-2 col-3 input-height-30"
              ><b>Clone</b></button>
          <div v-if="verrors.firstByRule('selected_publicTasklists', 'required')" class="margin-bottom-5 validate-warning-msg">Please Select Tasklist</div>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </CreateTasklistModal>

    <ValidationModal :isModalVisible="isInfoModalVisible" v-if="validationMessage" @close="isInfoModalVisible = false">
      <span class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">{{  validationMessage }}</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
      </div>
    </ValidationModal>

    <NaicsList :isModalVisible="isNaicsModalVisible" @close="isNaicsModalVisible = false">
      <div slot="header" class="sub-heading">
      </div>
      <div slot="body">
      </div>
      <div slot="footer" class="col-3 override-padding">
      </div>
    </NaicsList>

      <CheckValidationModal :isModalVisible="isValidateModalVisible" @close="isValidateModalVisible = false">       
        <div slot="header" class="sub-heading"><b>Account not inserted</b></div>
        <div slot="body">
          {{ researcherStatusValidationMsg }}
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </CheckValidationModal>






   </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import AdminTab from './account_lookup_admin_tab.vue';
import MenteeTab from './account_lookup_mentee_tab.vue';
import SearchMenteeTab from './account_lookup_mentee_search_tab.vue';
import FormTab from './account_lookup_forms_tab.vue';
import SearchFormTab from './account_lookup_search_forms_tab.vue';
import AffiliateTab from './account_lookup_affiliate_tab.vue';
import IndustryTab from './account_lookup_industry_tab.vue';
import NotesTab from './account_lookup_notes_tab.vue';
import PathwayTab from './account_lookup_pathway_tab.vue';
import GroupTab from './account_lookup_group_tab.vue';
import TasklistTab from './account_lookup_tasklists_tab.vue';
import MenuTab from './account_lookup_menu_tab.vue';
import PrivateTasklistTab from './account_lookup_private_tasklists_tab.vue';
import OrdersTab from './account_lookup_orders_tab.vue';
import PurchasingTab from './account_lookup_purchase_tab.vue';
import ValidationModal from '../shared/validation_modal_alert.vue';
import NaicsList from './account_lookup_naics_list.vue';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import autocomplete from './autocomplete.vue';
import autocompleteTo from './autocomplete.vue';
import autocompleteDescription from './autocomplete.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import ResearcherSidebarMenu from '../shared/researcher_sidebar_menu.vue';
import CreateTasklistModal from '../admin/create-tasklist-modal.vue';
import EnterpriseTab from './account_lookup_enterprise_tab.vue';
import HistoryTab from './account_lookup_history_tab.vue';
import CSRSidebarMenu from '../shared/csr_sidebar_menu.vue';
import CheckValidationModal from '../admin/account_lookup_researcher_status_validation_modal.vue';


Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
        data() {
          return {
            isInfoModalVisible: false,
            validationMessage: '',
            org_name: this.$store.getters.getSearchAccount.org_name ? this.$store.getters.getSearchAccount.org_name : '',
            website: this.$store.getters.getSearchAccount.website ? this.$store.getters.getSearchAccount.website : '',
            org_phone: this.$store.getters.getSearchAccount.org_phone ? this.$store.getters.getSearchAccount.org_phone : '',
            org_phone_ext: this.$store.getters.getSearchAccount.org_phone_ext ? this.$store.getters.getSearchAccount.org_phone_ext : '',
            fax: this.$store.getters.getSearchAccount.fax ? this.$store.getters.getSearchAccount.fax : '',
            location_api: this.$store.getters.getSearchAccount.location_api ? this.$store.getters.getSearchAccount.location_api : '',
            org_country: this.$store.getters.getSearchAccount.org_country ? this.$store.getters.getSearchAccount.org_country : '',
            country_options:  [],
            org_address: this.$store.getters.getSearchAccount.org_address ? this.$store.getters.getSearchAccount.org_address : '',
            org_address2: this.$store.getters.getSearchAccount.org_address2 ? this.$store.getters.getSearchAccount.org_address2 : '',
            org_city: this.$store.getters.getSearchAccount.org_city ? this.$store.getters.getSearchAccount.org_city : '',
            org_state: this.$store.getters.getSearchAccount.org_state ? this.$store.getters.getSearchAccount.org_state : '',
            state_options:  [],
            org_zip: this.$store.getters.getSearchAccount.org_zip ? this.$store.getters.getSearchAccount.org_zip : '',
            org_market_area: this.$store.getters.getSearchAccount.org_market_area ? this.$store.getters.getSearchAccount.org_market_area : '',
            naics_code: this.$store.getters.getSearchAccount.naics_code ? this.$store.getters.getSearchAccount.naics_code : '',
            naics_to_code: this.$store.getters.getSearchAccount.naics_to_code ? this.$store.getters.getSearchAccount.naics_to_code : '',
            naics_id: this.$store.getters.getSearchAccount.naics_id ? this.$store.getters.getSearchAccount.naics_id : '',
            naics_id_options: [],
            naics_description: this.$store.getters.getSearchAccount.naics_description ? this.$store.getters.getSearchAccount.naics_description : '',
            naics_label: this.$store.getters.getSearchAccount.naics_label ? this.$store.getters.getSearchAccount.naics_label : '',
            naics_label_options:  [
              { value: '', text: 'NAICS Label' },
              { value: 'Potential Competitor', text: 'Potential Competitor' },
              { value: 'Competitor', text: 'Competitor' },
              { value: 'Inactivated', text: 'Inactivated' },
            ],
            program:  this.$store.getters.getSearchAccount.program ? this.$store.getters.getSearchAccount.program : '',
            program_options:  [
              { value: '', text: 'Program' },
              { value: 'Mentorship', text: 'Mentorship' },
              { value: 'Apprenticeship', text: 'Apprenticeship' },
              { value: 'Mentorship & Apprenticeship', text: 'Mentorship & Apprenticeship' },
            ],
            primary_email: this.$store.getters.getSearchAccount.admin_email ? this.$store.getters.getSearchAccount.admin_email : '',
            primary_fname: this.$store.getters.getSearchAccount.admin_fname ? this.$store.getters.getSearchAccount.admin_fname : '',
            primary_lname: this.$store.getters.getSearchAccount.admin_lname ? this.$store.getters.getSearchAccount.admin_lname : '',
            status_updated_on: '',
            status: this.$store.getters.getSearchAccount.status ? this.$store.getters.getSearchAccount.status : '',
            status_options: [
              { value: '', text: 'Select Status' },
              { value: 'Active', text: 'Active' },
              { value: 'Inactive', text: 'Inactive' },
              { value: 'Prospect', text: 'Prospect' },
              { value: 'Delete', text: 'Deleted' },
            ],
            researcher_notes: '',
            selectedComponent: 'AdminTab',
            org_type_options: [
              { value: '', text: 'Select Account Type' },
              { value: 'Company', text: 'Company' },
              { value: 'School', text: 'School' },
            ],
            org_type: this.$store.getters.getSearchAccount.org_type ? this.$store.getters.getSearchAccount.org_type : '',
            mentee_tab_name: 'Users',
            isNaicsModalVisible: false,
            placeHolderInputText: '',
	          autoCompleteNaicsCodeResult: [],
	          autoCompleteNaicsCodeProgress: false,
            autoCompleteNaicsCodeToResult: [],
	          autoCompleteNaicsCodeToProgress: false,
            autoCompleteDescriptionResult: [],
	          autoCompleteDescriptionProgress: false,
            searchParameters: {
              account: {},
              admin: {},
              sort: {},
              affiliate: {},
              industry: {},
              search_mentee: {},
              search_form: {},
              flashReport: {},
            },
            total_pages: 0,
            showOverlay: false,
            accountId: 0,
            success_message: '',
            dismissCountDown: 0,
            account_type_disable: false,
            researcher_disable: false,
            isModalVisible: false,
            tasklists_options: [
              { value: 'New', text: 'New' },
              { value: 'Existing', text: 'Existing' }
            ],
            tasklists_option: 'New',
            existing_fields: false,
            new_fields: true,
            publicTasklists: [],
            tasklist_title: '',
            selected_publicTasklists: '',
            captured_account_data: [],
            researcher: false,
            masterAdmin: false,
            csr: false,
            isValidateModalVisible: false,
            researcherStatusValidationMsg: '',
          }
        },

        components: {
          UserMenu,
          AdminTab,
          MenteeTab,
          SearchMenteeTab,
          SearchFormTab,
          FormTab,
          ValidationModal,
          NaicsList,
          autocomplete,
          autocompleteTo,
          autocompleteDescription,
          MasteradminSidebarMenu,
          AffiliateTab,
          IndustryTab,
          CreateTasklistModal,
          NotesTab,
          PathwayTab,
          GroupTab,
          TasklistTab,
          MenuTab,
          PrivateTasklistTab,
          OrdersTab,
          PurchasingTab,
          EnterpriseTab,
          HistoryTab,
          ResearcherSidebarMenu,
          CSRSidebarMenu,
          CheckValidationModal,
        },
        computed: {
          isStatusDisable() {
            return (this.accountId > 0) ? true : false;
          },
          isResearcherDisable() {
            return (this.researcher == true && this.status != 'Prospect') ? true : false;
          }
        },
        methods: {
          countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
          },
          tasklistsOptions: function() {
             if(this.tasklists_option == 'New') {
               this.new_fields = true;
               this.existing_fields = false;
             }
             else {
               this.new_fields = false;
               this.existing_fields = true;
             }
          },
          createTasklist() {

            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                axios('/tasklist',
                   {
                     method: 'POST',
                     data: {name: this.tasklist_title, account_id: this.accountId},
                   }
                 )
                .then((resp) => {
                    this.tasklist_title = '';
                    this.isModalVisible = false;
                    let page_url = this.$route.fullPath;
                    let active_tab = 'PathwayTab';
                    let active_sub_tab = 'PrivateTasklistsTab';
                    this.$store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
                    this.$store.dispatch('subtasks', '');
                    router.push("/create-sub-tasklists/" + resp.data);
                 })
                .catch(error => {
                });
              }
            })
            .catch(() => {

            });
          },
          cloneTasklist: function() {
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                this.isModalVisible = false;
                this.showOverlay = true;
                axios('/clone-tasklist/' + this.selected_publicTasklists,
                 {
                   method: 'POST',
                   data: {account_id: this.accountId},
                 }
                )
                .then((resp) => {
                  this.showOverlay = false;
                  let page_url = this.$route.fullPath;
                  let active_tab = 'PathwayTab';
                  let active_sub_tab = 'PrivateTasklistsTab';
                  this.$store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
                  this.$store.dispatch('subtasks', '');
                  router.push("/create-sub-tasklists/" + resp.data);
                })
                .catch(error => {
                });
              }
            })
            .catch(() => {

            });
          },

          org_type_change: function() {
            if(this.org_type == 'Company') {
              this.mentee_tab_name = 'Users';
              if(this.selectedComponent == 'AdminTab') {
                this.$refs.AdminTab.mentor_label_name = 'Manager';
              }
              else if(this.selectedComponent == 'MenteeTab') {
                this.$refs.MenteeTab.mentor_label_name = 'Mentor(s)';
              }
            }
            else {
              this.mentee_tab_name = 'Student';
              if(this.selectedComponent == 'AdminTab') {
                this.$refs.AdminTab.mentor_label_name = 'Instructor';
              }
              else if(this.selectedComponent == 'MenteeTab') {
                this.$refs.MenteeTab.mentor_label_name = 'Groups';
              }
            }
          },
          program_change: function() {
            this.updateCapturedField('program', this.program);
            if(this.org_type == 'Company') {
              this.mentee_tab_name = 'Users';
              if(this.researcher == false) {
                if(this.selectedComponent == 'MenteeTab') {
                  this.$refs.MenteeTab.program_label = this.program;
                  this.$refs.MenteeTab.getUserTypeOptions();
                } else {
                  this.selectedComponent = 'MenteeTab';
                }
              }
            }
          },
          status_change: function () {
            if (this.selectedComponent == 'AdminTab') {
              this.$refs.AdminTab.admin_status_options = [];
              this.$refs.AdminTab.admin_status_options = [
                { value: '', text: 'Select Status' },
                { value: 'Active', text: 'Active' }, 
                { value: 'Inactive', text: 'Inactive' },
                { value: 'Prospect', text: 'Prospect' }
              ];
              for(var i=0; i<this.$refs.AdminTab.admin_contacts.length; i++) {
                var adminStatus = "";
                if (this.status == "") {
                  adminStatus = "Prospect";
                } else {
                  if (this.status == "Delete") {
                    adminStatus = "";
                  } else {
                    adminStatus = this.status;
                  }
                }
                this.$refs.AdminTab.admin_contacts[i].admin_status = adminStatus;
              }
            }
          },
          website_redirect: function() {
            var website = this.website;
            var pattern = /^(http(s)?:\/\/)/;
            if(!pattern.test(website)) {
                website = "http://" + website;
            }
            window.open(website, '_blank');
          },

          onSelectedAutoCompleteNaicsCode(item){
            this.autoCompleteNaicsCodeProgress = false;
            this.autoCompleteNaicsCodeResult = [];
            this.naics_code = item.naicsCode.toString();
            this.$refs.autocomplete1.setValue(item.naicsCode);
            this.$refs.autocomplete3.setValue(item.description);
            this.naics_description = item.description;
            this.naics_id = item.naicsId;
            this.updateCapturedField('naicsDescription', item.description);
            this.updateCapturedField('naicsId', item.naicsId);
            this.updateCapturedField('naicsCode', item.naicsCode);
          },
          onKeyUpAutoCompleteNaicsCode(keywordEntered){
      			this.autoCompleteNaicsCodeResult = [];
            this.naics_code = keywordEntered;
      			this.autoCompleteNaicsCodeProgress = false;
      			if(keywordEntered.length > 0){
      				this.autoCompleteNaicsCodeProgress = true;
              const params = { naics_code: keywordEntered }
              if (this.naics_id) {
                params.naics_id = this.naics_id;
              }
              if (this.naics_description) {
                params.naics_description = this.naics_description;
              }
      				axios.get("/naics_autocomplete", {
                 params: params
              })
      				.then(response => {
      					var newData = [];
      					response.data.forEach(function(item, index){
      						if(item.naicsCode){
                    newData.push({
                      'itemId' : item.naicsCode,
                      'itemText' : item.naicsCode + '-' + item.description,
                      'itemList': item,
                    });
      						}
      					});
      					this.autoCompleteNaicsCodeResult = newData;
      					this.autoCompleteNaicsCodeProgress = false;
      				})
      				.catch(e => {
      					this.autoCompleteNaicsCodeProgress = false;
      					this.autoCompleteNaicsCodeResult = [];
      				})
      			}else{
      				this.autoCompleteNaicsCodeProgress = false;
      				this.autoCompleteNaicsCodeResult = [];
      			}
      		},
          onSelectedAutoCompleteNaicsCodeTo(item){
            this.autoCompleteNaicsCodeToProgress = false;
            this.autoCompleteNaicsCodeToResult = [];
            this.naics_to_code = item.naicsCode.toString();
            this.$refs.autocomplete2.setValue(item.naicsCode);
            this.updateCapturedField('naicsCode', item.naicsCode);
          },
          onKeyUpAutoCompleteNaicsCodeTo(keywordEntered){
      			this.autoCompleteNaicsCodeToResult = [];
            this.naics_to_code = keywordEntered;
      			this.autoCompleteNaicsCodeToProgress = false;
      			if(keywordEntered.length > 0){
      				this.autoCompleteNaicsCodeToProgress = true;
              const params = { naics_code: keywordEntered }
              if (this.naics_id) {
                params.naics_id = this.naics_id;
              }
              if (this.naics_description) {
                params.naics_description = '';
              }
      				axios.get("/naics_autocomplete", {
                 params: params
              })
      				.then(response => {
      					var newData = [];
      					response.data.forEach(function(item, index){
      						if(item.naicsCode){
                    newData.push({
                      'itemId' : item.naicsCode,
                      'itemText' : item.naicsCode,
                      'itemList': item,
                    });
      						}
      					});
      					this.autoCompleteNaicsCodeToResult = newData;
      					this.autoCompleteNaicsCodeToProgress = false;
      				})
      				.catch(e => {
      					this.autoCompleteNaicsCodeToProgress = false;
      					this.autoCompleteNaicsCodeToResult = [];
      				})
      			}else{
      				this.autoCompleteNaicsCodeToProgress = false;
      				this.autoCompleteNaicsCodeToResult = [];
      			}
      		},
          onSelectedAutoCompleteDescription(item){
            this.autoCompleteDescriptionProgress = false;
            this.autoCompleteDescriptionResult = [];
            this.naics_description = item.description;
            this.$refs.autocomplete3.setValue(item.description);
            this.$refs.autocomplete1.setValue(item.naicsCode);
            this.naics_code = item.naicsCode.toString();
            this.naics_id = item.naicsId;
            this.updateCapturedField('naicsDescription', item.description);
            this.updateCapturedField('naicsId', item.naicsId);
            this.updateCapturedField('naicsCode', item.naicsCode);
          },
          onKeyUpAutoCompleteDescription(keywordEntered){
      			this.autoCompleteDescriptionResult = [];
            this.naics_description = keywordEntered;
      			this.autoCompleteDescriptionProgress = false;
      			if(keywordEntered.length > 0){
      				this.autoCompleteDescriptionProgress = true;
              const params = { naics_description: keywordEntered }
              if (this.naics_id) {
                params.naics_id = this.naics_id;
              }
              if (this.naics_code) {
                params.naics_code = '';
              }
      				axios.get("/naics_autocomplete", {
                 params: params
              })
      				.then(response => {
      					var newData = [];
      					response.data.forEach(function(item, index){
      						if(item.description){
                    newData.push({
                      'itemId' : item.description,
                      'itemText' : item.description,
                      'itemList': item,
                    });
      						}
                });
      					this.autoCompleteDescriptionResult = newData;
      					this.autoCompleteDescriptionProgress = false;
      				})
      				.catch(e => {
      					this.autoCompleteDescriptionProgress = false;
      					this.autoCompleteDescriptionResult = [];
      				})
      			}else{
      				this.autoCompleteDescriptionProgress = false;
      				this.autoCompleteDescriptionResult = [];
      			}
      		},
          removeNAICSValue: function() {
            this.$refs.autocomplete3.setValue('');
            this.$refs.autocomplete1.setValue('');
            this.naics_to_code = '';
            this.naics_code = '';
            this.naics_description = '';
            this.autoCompleteNaicsCodeProgress = false;
            this.autoCompleteNaicsCodeResult = [];
            this.autoCompleteNaicsCodeToProgress = false;
            this.autoCompleteNaicsCodeToResult = [];
            this.autoCompleteDescriptionResult = [];
	          this.autoCompleteDescriptionProgress = false;
          },
          closeModal() {
            this.$emit('close');
          },
          naicsListModal: function() {
            this.isNaicsModalVisible = true;
          },
          phoneRegex: function() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
          },
          getPostalCodeRegex() {
            if (this.org_country == "US") {
              return /^[0-9]{5}(?:-[0-9]{4})?$/;
            } else if (this.org_country == "CA") {
              return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
            }
            return /./;
          },
          naicsValuesAction: function(naicslist) {
            this.$refs.autocomplete3.setValue(naicslist.description);
            this.$refs.autocomplete1.setValue(naicslist.naicsCode);
            this.naics_id = naicslist.naicsId;
            this.naics_code = naicslist.naicsCode.toString();
            this.naics_description = naicslist.description;
            this.isNaicsModalVisible = false;
            this.updateCapturedField('naicsDescription', naicslist.description);
            this.updateCapturedField('naicsId', naicslist.naicsId);
            this.updateCapturedField('naicsCode', naicslist.naicsCode);
          },
          checkValidation: function() {
            if(this.selectedComponent == 'AdminTab') {
              this.checkSameEmailUsed();
              setTimeout(() => {
                if(this.validationMessage == '') {
                  this.$children.forEach(vm => {
                    vm.$validator.validateAll();
                  });

                  this.$validator.validateAll().then((result) => {
                    if ((this.verrors.items.length === 0)) {
                      if(this.accountId > 0) {
                        this.updateAccountUserAction();
                      }
                      else {
                        this.insertAccountUserAction();
                      }

                    }
                  })
                  .catch(() => {

                  });
                }
              }, 1000);
            }
          },

          checkSameEmailUsed: function() {
            this.validationMessage = '';
            var mailFirst = this.$refs.AdminTab.admin_contacts;
            var mailSecond = this.$refs.AdminTab.admin_contacts;
            for(var i=0; i < mailFirst.length; i++) {
              for(var j=0; j < mailSecond.length; j++) {
                if((i != j) && (mailFirst[i].admin_email != '') && (mailSecond[j].admin_email != '')) {
                  if(mailFirst[i].admin_email == mailSecond[j].admin_email) {
                      this.validationMessage = 'Please give unique email for each admin';
                      this.isInfoModalVisible = true;
                      return false;
                  }
                }
              }
            }
          },
          checkResearcherStatusValidation: function() {
            var flag = 1;
            this.researcherStatusValidationMsg = '';
            if(this.status != 'Prospect') {
              flag = 0;
              this.researcherStatusValidationMsg = 'Please change the Account Status to Prospect';
              this.isValidateModalVisible = true;
            }
            if(this.researcherStatusValidationMsg == '') {
              var admin_contacts = this.$refs.AdminTab.admin_contacts;
              for(var j=0; j < admin_contacts.length; j++) {
                  if(admin_contacts[j].admin_status != 'Prospect') {
                    flag = 0;
                    this.researcherStatusValidationMsg = 'Please change the Admin Status to Prospect';
                    this.isValidateModalVisible = true; 
                  }
              }
            }

            return flag;
          },
          insertAccountUserAction: function() {
            var flag = 1;
            var roles = this.$store.state.roles;
            if(roles.indexOf('ROLE_RESEARCHER') > -1) {
              var flag = this.checkResearcherStatusValidation();
            }
            if(flag == 1) {
            axios('/account_lookup_insert',
              {
                method: 'POST',
                data: {
                       "account": {
                           "company_name": this.org_name,
                           "master_admin": false,
                           "school_flag": this.org_type,
                           "website": this.website,
                           "phone_no": this.org_phone,
                           "phone_ext": this.org_phone_ext,
                           "fax": this.fax,
                           "status": this.status ? this.status : 'Prospect',
                           "naics_code": this.naics_code,
                           "naics_id": this.naics_id,
                           "naics_description": this.naics_description,
                           "naics_label": this.naics_label,
                           "researcher_notes": this.researcher_notes,
                           "location": {
                             "address": this.org_address,
                             "address2": this.org_address2,
                             "country_code": this.org_country,
                             "state_code": this.org_state,
                             "city": this.org_city,
                             "zip": this.org_zip,
                             "market_area": this.org_market_area,
                           },
                           "program": this.program,
                         },
                         "userInfo": this.$refs.AdminTab.admin_contacts,
                       }
              },
            )
            .then(response => {
              this.success_message = 'Account created successfully.';
              this.dismissCountDown = 5;
              this.$router.push("/account-lookup-detail/" + response.data);
             })
            .catch(error => {
                  const fieldErrors =  [];
                  const fieldErrors1 =  [];
                  var error_msg = error.response.data.message;
                  var data_array = error_msg.split(',');
                  for(var i=0; i<data_array.length; i++) {
                    var data_array_value = data_array[i];
                    console.log(data_array_value);
                    data_array_value = data_array_value.replace("{", "");
                    data_array_value = data_array_value.replace("}", "");
                    data_array_value = "{"+data_array_value+"}";
                    var errMsgObj = JSON.parse(data_array_value);
                    console.log(errMsgObj);
                    Object.keys(errMsgObj).map(key => {
                     if(key == 'accountName') {
                       var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                       fieldErrors1.push(newFieldErr);
                     }
                     else {
                       var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                       fieldErrors.push(newFieldErr);
                     }
                    });

                  }
                  console.log(fieldErrors1);
                  console.log(fieldErrors);
                  this.$refs.AdminTab.$validator.errors.add(fieldErrors);
                  this.$validator.errors.add(fieldErrors1);
             });
             }
          },
          updateAccountUserAction: function() {
            var insertUserInfo = [];
            for(var i=0; i<this.$refs.AdminTab.admin_contacts.length; i++) {
              if(this.$refs.AdminTab.admin_contacts[i].uid == 0) {
                Vue.set(insertUserInfo, i, this.$refs.AdminTab.admin_contacts[i]);
              }
            }
            axios('/account_lookup_update',
              {
                method: 'POST',
                data: {
                       "account": {
                           "company_name": this.org_name,
                           "master_admin": false,
                           "school_flag": this.org_type,
                           "website": this.website,
                           "phone_no": this.org_phone,
                           "phone_ext": this.org_phone_ext,
                           "fax": this.fax,
                           "status": this.status ? this.status : 'Active',
                           "naics_code": this.naics_code,
                           "naics_id": this.naics_id,
                           "naics_description": this.naics_description,
                           "naics_label": this.naics_label,
                           "researcher_notes": this.researcher_notes,
                           "location": {
                             "address": this.org_address,
                             "address2": this.org_address2,
                             "country_code": this.org_country,
                             "state_code": this.org_state,
                             "city": this.org_city,
                             "zip": this.org_zip,
                             "market_area": this.org_market_area,
                           },
                           "account_id": this.accountId,
                           "program": this.program,
                         },
                         "insertUserInfo": insertUserInfo,
                         "updateUserInfo": this.$refs.AdminTab.updated_admin_contacts,
                         "capturedAccountInfo": this.captured_account_data,
                       }
              },
            )
            .then(response => {
              this.$refs.AdminTab.updated_admin_contacts = {};
              this.success_message = 'Account is updated.';
              this.dismissCountDown = 5;
              this.$refs.AdminTab.getAdminListData();
              this.getAccountLookupDetailData();
              this.$router.push(this.$router.currentRoute);
             })
            .catch(error => {
              if(error.response) {
                const fieldErrors =  [];
                // var errMsgObj = error.response.data.message;
                // Object.keys(errMsgObj).map(key => {
                //  var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                //  fieldErrors.push(newFieldErr);
                // });

                var error_msg = error.response.data.message;
                var data_array = error_msg.split(',');

                for (var i = 0; i < data_array.length; i++) {
                  var data_array_value = data_array[i];
                  data_array_value = data_array_value.replace("{", "");
                  data_array_value = data_array_value.replace("}", "");
                  data_array_value = "{" + data_array_value + "}";
                  var errMsgObj = JSON.parse(data_array_value);

                  Object.keys(errMsgObj).map(key => {
                    var newFieldErr = { field: key, msg: errMsgObj[key], rule: 'exists' };
                    fieldErrors.push(newFieldErr);
                  });
                }

                this.$refs.AdminTab.$validator.errors.add(fieldErrors);
              }
            });
          },
          searchAction: function() {
            if(this.accountId == '') {
            store.dispatch('search_parameters', '');
            store.dispatch('clear_search_accounts');
            this.searchParameters.account.org_name = this.org_name;
            this.searchParameters.account.website = this.website;
            this.searchParameters.account.org_phone = this.org_phone;
            this.searchParameters.account.org_phone_ext = this.org_phone_ext;
            this.searchParameters.account.fax = this.fax;
            this.searchParameters.account.org_country = this.org_country;
            this.searchParameters.account.org_address = this.org_address;
            this.searchParameters.account.org_address2 = this.org_address2;
            this.searchParameters.account.org_city = this.org_city;
            this.searchParameters.account.org_state = this.org_state;
            this.searchParameters.account.org_zip = this.org_zip;
            this.searchParameters.account.org_market_area = this.org_market_area;
            this.searchParameters.account.naics_code = this.naics_code;
            this.searchParameters.account.naics_to_code = this.naics_to_code;
            this.searchParameters.account.naics_id = this.naics_id;
            this.searchParameters.account.naics_description = this.naics_description;
            this.searchParameters.account.naics_label = this.naics_label;
            this.searchParameters.account.status = this.status ? this.status : ['Active', 'Inactive', 'Prospect'];
            this.searchParameters.account.researcher_notes = this.researcher_notes;
            this.searchParameters.account.org_type = this.org_type;

            if(this.selectedComponent == 'AdminTab') {
              var admin_contact = this.$refs.AdminTab.admin_contacts[0];
              this.searchParameters.admin.admin_fname = admin_contact.admin_fname;
              this.searchParameters.admin.admin_lname = admin_contact.admin_lname;
              this.searchParameters.admin.admin_email = admin_contact.admin_email;
              this.searchParameters.admin.admin_title = admin_contact.admin_title;
              this.searchParameters.admin.is_enabled = admin_contact.is_enabled;
              this.searchParameters.admin.is_manager = admin_contact.is_manager;
              this.searchParameters.admin.is_news = admin_contact.is_news;
              this.searchParameters.admin.is_billingadmin = admin_contact.is_billingadmin;
              this.searchParameters.admin.is_primaryadmin = admin_contact.is_primaryadmin;
              this.searchParameters.admin.id_number = admin_contact.id_number;
              this.searchParameters.admin.mobile = admin_contact.mobile;
              this.searchParameters.admin.phone = admin_contact.phone;
              this.searchParameters.admin.phone_ext = admin_contact.phone_ext;
              this.searchParameters.admin.location_name = admin_contact.location_name;
              this.searchParameters.admin.country = admin_contact.country;
              this.searchParameters.admin.address = admin_contact.address;
              this.searchParameters.admin.address2 = admin_contact.address2;
              this.searchParameters.admin.city = admin_contact.city;
              this.searchParameters.admin.zip = admin_contact.zip;
              this.searchParameters.admin.state = admin_contact.state;
              this.searchParameters.admin.market_area = admin_contact.market_area;
            }
            if(this.selectedComponent == 'SearchMenteeTab') {
              var account_mentee = this.$refs.SearchMenteeTab.account_mentee;
              this.searchParameters.search_mentee.mentee_fname = account_mentee.mentee_fname;
              this.searchParameters.search_mentee.mentee_lname = account_mentee.mentee_lname;
              this.searchParameters.search_mentee.mentee_email = account_mentee.mentee_email;
              this.searchParameters.search_mentee.mentee_phone = account_mentee.mentee_phone;
              this.searchParameters.search_mentee.mentee_is_active = account_mentee.mentee_is_active;
            }
            if(this.selectedComponent == 'AffiliateTab') {
              var affiliateId = this.$refs.AffiliateTab.affiliate;
              this.searchParameters.affiliate.id = affiliateId;
            } else {
              this.searchParameters.affiliate.id = '';
            }
            if(this.selectedComponent == 'IndustryTab') {
              var industryId = this.$refs.IndustryTab.industry;
              this.searchParameters.industry.id = industryId;
            } else {
              this.searchParameters.industry.id = '';
            }
            if (this.selectedComponent == 'SearchFormTab') {
              var formId = this.$refs.SearchFormTab.form_affiliates;
              this.searchParameters.search_form.form_ids = formId;
            } else {
              this.searchParameters.search_form.form_ids = '';
            }
            this.searchParameters.sort.sortField = 'companyName';
            this.searchParameters.sort.sortBy = 'ASC';
            this.searchParameters.flashReport.info = '';
            this.searchParameters.flashReport.type = '';
            store.dispatch('search_parameters', this.searchParameters);
            router.push("/account-lookup/view-list");
            }
          },
          phoneValid: function(event) {
            var phone = this.org_phone;
            this.org_phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
          },
          faxValid: function(event) {
            var phone = this.fax;
            this.fax = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
          },
          phoneExtValid: function(event) {
            var phone = this.org_phone_ext;
            this.org_phone_ext = phone.replace(/[^0-9]/g, '');
          },
          getCountryLists: function () {
            axios.get('/get-country-lists', {

            })
            .then(response =>  {
              this.country_options = response.data;
            })
            .catch(function(error) {

            });
          },
          getStateLists: function (CountryCode) {
            this.org_state = this.$store.getters.getSearchAccount.org_state ? this.$store.getters.getSearchAccount.org_state : '';
            if(CountryCode == '') {
              CountryCode = null;
              this.updateCapturedField('state', this.org_state);
            }
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
              this.state_options = response.data;
            })
            .catch(function(error) {

            });
          },
          updateCountryUS: function() {
            this.org_country = 'US';
            this.getStateLists(this.org_country);
          },
          placeAddressComponent: function(addressComponents) {
            var assocArray = [];
            for(var i=0; i<addressComponents.length; i++) {
              var data_value = addressComponents[i].short_name;
              var data_key = addressComponents[i].types[0];
              assocArray[data_key] = data_value;
            }
            this.org_zip = this.org_city = this.org_country = this.org_state = this.org_address = this.org_address2 = '' ;
            if(assocArray['postal_code']) {
              this.org_zip = assocArray['postal_code'];
              this.updateCapturedField('zip', this.org_zip);
            }
            if(assocArray['locality']) {
              this.org_city = assocArray['locality'];
              this.updateCapturedField('city', this.org_city);
            }
            if(assocArray['country']) {
              this.org_country = assocArray['country'];
              this.getStateLists(this.org_country);
              this.updateCapturedField('countryCode', this.org_country);
            }
            if(assocArray['administrative_area_level_1']) {
              this.org_state = assocArray['administrative_area_level_1'];
              this.updateCapturedField('state', this.org_state);
            }
            if(assocArray['street_number']) {
              this.org_address = assocArray['street_number'];
              this.updateCapturedField('address', this.street_number);
            }
            if(assocArray['route']) {
              if(this.org_address) {
                this.org_address = this.org_address + ' ' + assocArray['route'];
              }
              else {
                this.org_address = assocArray['route'];
              }
              this.updateCapturedField('address', this.org_address);
            }
          },
          getalltasklists: function() {
            axios.get('/alltasklists-account', {
              params: {
                account_id: this.accountId,
              }
            })
            .then(response =>  {
              this.publicTasklists = [];
              this.publicTasklists.push({value: '', text: 'Select Tasklist'});
              for(var i=0; i < response.data.length; i++) {
                var tasklistOption = {value: response.data[i].id, text: response.data[i].name};
                this.publicTasklists.push(tasklistOption);
              }
            })
            .catch(function(error) {

            });
          },
          getSearchListAccountDetails: function(data, fromPage) {
            this.org_name = data.accountName;
            this.website = data.website;
            this.org_phone = data.phoneNumber;
            this.org_phone_ext = data.phoneExt;
            this.fax = data.fax;
            this.org_country = data.countryCode;
            this.getStateLists(this.org_country);
            this.org_address = data.address;
            this.org_address2 = data.address2;
            this.org_city = data.city;
            this.org_state = data.state;
            this.org_zip = data.zip;
            this.org_market_area = data.marketArea;
            this.naics_code = data.naicsCode.toString();;
            this.naics_id = data.naicsId;
            this.naics_description = data.naicsDescription;
            this.$refs.autocomplete3.setValue(data.naicsDescription);
            this.$refs.autocomplete1.setValue(data.naicsCode);
            this.naics_label = data.naicsLabel;
            this.researcher_notes = data.researcherNotes;
            this.status = data.status;
            this.status_updated_on = data.statusUpdatedAt;
            if(fromPage != 'search_results') {
               this.primary_fname = data.primary_fname;
               this.primary_lname = data.primary_lname;
               this.primary_email = data.primary_email;
            }            
            this.program = data.program;
            if(data.schoolFlag == 1) {
              this.org_type = 'School';
              this.mentee_tab_name = 'Student';
              this.$refs.AdminTab.mentor_label_name = 'Instructor';
            }
            else {
              this.org_type = 'Company';
              this.mentee_tab_name = 'Users';
              this.$refs.AdminTab.mentor_label_name = 'Manager';
            }
            this.accountId = data.accId;
            this.location_api = '';
            this.account_type_disable = data.accountTypeDisable;
            this.researcher_disable = data.researcher_disable;
            if(this.researcher == false) {
              this.getalltasklists();
            }
          },
          previousPagination: function() {
            this.showOverlay = true;
            this.selectedComponent = 'AdminTab';
            var count = parseInt(this.$route.query.count) - parseInt(1);
            if(count >= 0) {
              this.$router.replace({ path: 'account-lookup', query: { count: count }});
            }
          },
          nextPagination: function() {
            this.showOverlay = true;
            this.selectedComponent = 'AdminTab';
            var count = parseInt(this.$route.query.count) + parseInt(1);
            if((count >= 0) && (count < this.total_pages)) {
              this.$router.replace({ path: 'account-lookup', query: { count: count }});
            }
          },
          clearSearchAction: function() {
            store.dispatch('search_parameters', '');
            store.dispatch('clear_search_accounts');
            this.flash({ message: "Search cleared.", variant: 'success' });
            router.push("/account-lookup");
            location.reload();
          },
          getAccountListData: function() {
            if((this.$route.query.count >= 0)) {
              if((store.state.search_parameters)) {
              var searchParam = store.state.search_parameters;
              searchParam.page = parseInt(this.$route.query.count) + parseInt(1);
                axios("/account_lookup_search_list", {
                  method: 'POST',
                  data: {
                    search_parameters: searchParam,
                  }
                })
                .then(response => {
                  this.captured_account_data = response.data.data.captured_account_data;
                  this.getSearchListAccountDetails(response.data.data[0], 'search_results');
                  this.$refs.AdminTab.admin_contacts = response.data.data.admin_contacts;
                  this.$refs.AdminTab.updated_admin_contacts = {};
                  this.total_pages = response.data.total_pages;
                  this.showOverlay = false;

                  //assign primary admin details
                  for( let i=0; i<response.data.data.admin_contacts.length; i++) {
                      let contact = {};
                      contact = response.data.data.admin_contacts[i];
                      
                      Object.entries(contact).forEach(([key, value]) => {
                        if (key == 'is_primaryadmin' && value == 1) {                         
                          this.primary_fname = contact.admin_fname;
                          this.primary_lname = contact.admin_lname;
                          this.primary_email = contact.admin_email;
                        }                        
                      });
                  }
                })
                .catch(error => {

                });

              }
              else {
                this.flash({ message: "You cleared your search criteria.", variant: 'danger' });
                router.push("/account-lookup");
              }
            }
          },
          getAccountLookupDetailData: function() {

            axios("/account_lookup_detail", {
              method: 'GET',
              params: {
                account_id: this.accountId,
              }
            })
            .then(response => {
              this.captured_account_data = response.data.data.captured_account_data;
              this.getSearchListAccountDetails(response.data.data[0], 'detail');
              this.$refs.AdminTab.admin_contacts = response.data.data.admin_contacts;
              this.$refs.AdminTab.updated_admin_contacts = {};
            })
            .catch(error => {

            });
          },

          insertMenteeAction: function() {
            this.$children.forEach(vm => {
              vm.$validator.validateAll();
            });
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
              var insertMenteeInfo = [];
              var updateMenteeInfo = [];
              var account_has_license = this.$refs.MenteeTab.account_has_license_qty;
              var mentee_assigned_license_count = 0;
              for(var i=0; i<this.$refs.MenteeTab.account_mentees.length; i++) {
                if(this.$refs.MenteeTab.account_mentees[i].uid == 0) {
                  Vue.set(insertMenteeInfo, i, this.$refs.MenteeTab.account_mentees[i]);
                  if(this.$refs.MenteeTab.account_mentees[i].assign_license == true) {
                    mentee_assigned_license_count = parseInt(mentee_assigned_license_count + 1);
                  }
                }
              }
              if(mentee_assigned_license_count > account_has_license) {
                alert("Assigned license to mentee is more than total account active license");
              }
              axios('/account_lookup_mentee_update/' + this.accountId,
                  {
                    method: 'POST',
                    data: {
                             "insertMenteeDetails": insertMenteeInfo,
                             "updateMenteeDetails": this.$refs.MenteeTab.updated_account_mentees,
                             "account": {
                              "account_id": this.accountId,
                              "program": this.program,
                             },
                             "capturedAccountInfo": this.captured_account_data,
                          }
                  },
                )
                .then(response => {
                    if(this.org_type == 'Company') {
                      this.success_message = 'Users details are updated.';
                    }
                    else {
                      this.success_message = 'Student details are updated';
                    }
                    this.dismissCountDown = 5;
                    this.$refs.MenteeTab.updated_account_mentees = {} ;
                    this.$refs.MenteeTab.getMenteeListData();
                 })
                .catch(error => {
                  const fieldErrors =  [];
                  // var errMsgObj = error.response.data.message;
                  var errorCode = error.response.data.code;
                  if(errorCode == 430) {
                    var errMsgObj = error.response.data.message;
                    //alert(errMsgObj)
                    this.validationMessage = errMsgObj;
                    this.isInfoModalVisible = true;
                  }
                  else {
                    var errMsgObj = JSON.parse(error.response.data.message);
                    Object.keys(errMsgObj).map(key => {
                     var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                     fieldErrors.push(newFieldErr);
                    });
                    this.$refs.MenteeTab.$validator.errors.add(fieldErrors);
                  }
                })

                }
            })
            .catch(() => {

            });

          },
          insertAffiliateAction: function() {            
            setTimeout(() => {
              if(this.validationMessage == '') {
                this.$children.forEach(vm => {
                  vm.$validator.validateAll();
                });

                this.$validator.validateAll().then((result) => {
                  if ((this.verrors.items.length === 0)) {
                    axios('/account_lookup_affiliate_update/' + this.accountId,
                      {
                        method: 'POST',
                        data: {
                                  affiliateId: this.$refs.AffiliateTab.affiliate,
                                  pricingAffiliate: this.$refs.AffiliateTab.pricingAffiliate,
                              }
                      },
                    )
                    .then(response => {
                        this.success_message = 'Account is updated..';
                        this.dismissCountDown = 5;
                        this.$refs.AffiliateTab.fetchAffiliatesLists();
                        this.$refs.AffiliateTab.getAccountAffiliate();
                        this.getalltasklists();
                        this.$router.push(this.$router.currentRoute);
                      })
                    .catch(error => {

                    })
                  }

                })
                .catch(() => {

                });
              }
            }, 1000);
          },
          insertIndustryAction: function() {
            setTimeout(() => {
              if(this.validationMessage == '') {
                this.$children.forEach(vm => {
                  vm.$validator.validateAll();
                });

                this.$validator.validateAll().then((result) => {
                  if ((this.verrors.items.length === 0)) {
                    axios('/account_lookup_industry_update/' + this.accountId,
                      {
                        method: 'POST',
                        data: {
                                  industryId: this.$refs.IndustryTab.industry,
                              }
                      },
                    )
                    .then(response => {
                        this.success_message = 'Account is updated..';
                        this.dismissCountDown = 5;
                        this.$refs.IndustryTab.fetchIndustryLists();
                        this.$refs.IndustryTab.getAccountIndustry();                        
                        this.$router.push(this.$router.currentRoute);
                      })
                    .catch(error => {

                    })
                  }

                })
                .catch(() => {

                });
              }
            }, 1000);
          },
          insertGroupAction: function() {
            this.$children.forEach(vm => {
              vm.$validator.validateAll();
            });
            var insertGroupInfo = [];
            for(var i=0; i<this.$refs.GroupTab.account_groups.length; i++) {
              if(this.$refs.GroupTab.account_groups[i].gid == 0) {
                Vue.set(insertGroupInfo, i, this.$refs.GroupTab.account_groups[i]);
              }
            }
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {

                axios('/account-groups/' + this.accountId,
                    {
                      method: 'POST',
                      data: {
                              insertAccountGroups: insertGroupInfo,
                              updateAccountGroups: this.$refs.GroupTab.updated_account_groups,
                            }
                    },
                  )
                  .then(response => {
                      this.$refs.GroupTab.updated_account_groups = [];
                      this.success_message = 'Group is updated.';
                      this.dismissCountDown = 5;
                      this.$refs.GroupTab.getGroupListData();
                      this.$router.push(this.$router.currentRoute);
                  })
                  .catch(error => {

                  })
              }
            })
            .catch(() => {

            });
          },
          update_selected_tab_details() {
            if (this.selectedComponent === 'MenteeTab') {
              this.insertMenteeAction();
            }
            else if (this.selectedComponent === 'AffiliateTab') {
              this.insertAffiliateAction();
            }
            else if (this.selectedComponent === 'IndustryTab') {
              this.insertIndustryAction();
            }
            else if (this.selectedComponent === 'AdminTab') {
              this.checkValidation();
            }
            else if (this.selectedComponent === 'GroupTab') {
              this.insertGroupAction();
            }
          },
          displayEmailLoginList() {
            router.push('/account-lookup/admin-email-list/' + this.accountId)
          },
          clearSearchAccounts: function() {
            store.dispatch('set_search_accounts', '');
          },
          addEvent ({ type, target }) {
            if (this.accountId) {
              var name = target.name;
              if (name === "location api") {
                return;
              }
              if(this.captured_account_data['accId'].old_value > 0) {
                var value;
                if((target.type == 'checkbox') || (target.type == 'radio')) {
                  value = target.checked;
                }
                else {
                  value = target.value;
                }
                if (name) {
                  this.updateCapturedField(name, value);
                }
                // console.log(this.captured_account_data[name]['old_value'] + " >> "  + this.captured_account_data[name]['new_value'])
              }
            }
          },
          updateCapturedField(fieldName, fieldValue) {
            if (this.accountId) {
              this.captured_account_data[fieldName]['new_value'] = fieldValue;
              this.captured_account_data[fieldName]['is_modified'] = 1;
            }
          }
        },
        watch: {
            '$route.query.count'() {
              document.getElementById("location_api").value = "";
              this.getAccountListData();
            },
            '$route.params.account_id'() {
              this.accountId = this.$route.params.account_id;
              this.getAccountLookupDetailData();
            }
        },
        mounted() {
          this.clearSearchAccounts();
          setTimeout(() => {
            this.autocomplete = new google.maps.places.Autocomplete(
              (this.$refs.location_api),
              {
                types: [],
                componentRestrictions: {country: ['us', 'ca']},
              }
            );
            this.autocomplete.addListener('place_changed', () => {
              let place = this.autocomplete.getPlace();
              this.placeAddressComponent(place.address_components);
            });
          }, 1000);
          this.$on('VeeValidate', () => {
            EventBus.$emit('VeeValidate');
          });
        },
        created() {
          this.getCountryLists();
          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          if(roles.indexOf('ROLE_RESEARCHER') > -1) {
            this.researcher = true;
            this.status = 'Prospect';
          }
          if(roles.indexOf('ROLE_CSR') > -1) {
            this.csr = true;
          }
          if(this.researcher == true) {
            this.status_options = [
              { value: '', text: 'Select Status' },
              { value: 'Active', text: 'Active' },
              { value: 'Inactive', text: 'Inactive' },
              { value: 'Prospect', text: 'Prospect' },
            ]
          }
          this.getStateLists(this.org_country);
          if(store.state.search_parameters) {
            this.searchParameters = store.state.search_parameters;
          }
          if((this.$route.params.account_id >= 0)) {
            this.accountId = this.$route.params.account_id;
            this.getAccountLookupDetailData();
          }
          this.getAccountListData();

          setTimeout(() => {
            if(this.accountId > 0) {
              if(store.state.page_url) {
                if((store.state.page_url.indexOf('account-lookup') > -1) || ((store.state.page_url.indexOf('account-lookup-detail') > -1))) {
                  if((store.state.active_tab)) {
                    this.selectedComponent = store.state.active_tab;
                  }
                }
              }
            }
          }, 1500);
        },
        beforeCreate() {
          let googlePlaceAPI = document.createElement('script');
          googlePlaceAPI.setAttribute('src',"https://maps.googleapis.com/maps/api/js?key=" + process.env.PLACE_API_KEY + "&libraries=places");
          document.head.appendChild(googlePlaceAPI);
          axios('/naicsids',
           {
              method: 'GET',
           },
          )
          .then(response => {
              this.naics_id_options.push({value: '', text: 'NAICS ID'});
              for(var i=0; i < response.data.length; i++) {
                var naicsIdOption = {value: response.data[i].id, text: response.data[i].title};
                this.naics_id_options.push(naicsIdOption);
              }
           })
          .catch(error => {

          });
        }
    }
</script>

<style scoped>
@import '../../assets/styles/account_lookup.css';
.width-90 {
  width: 89%;
}
.width-10 {
  width: 11%;
}
.custom-select {
  height: 30px !important;
}
.alert-warning {
  text-align: center;
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
.alert-warning::before {
  content: '\f06a';
  font-family: FontAwesome;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup.vue